exports.api_host =
  process.env.NODE_ENV == "production"
    ? window.apihost
    : // ? process.env.VUE_APP_API_URL
      "http://localhost:3100";

exports.local_api = (vm, method, resource, params = {}) => {
  let c = this;
  return new Promise(function (resolve, reject) {
    resource = `${c.api_host}${resource}`;
    // resource = `http://api.demo.gomodul.com${resource}`;
    let methods = {
      post: vm.$http.post,
      get: vm.$http.get,
    };

    let token = vm.$session.get("token");
    let config = { timeout: 600000 };
    if (token) {
      config.headers = {
        "x-access-token": token,
      };
    }

    let _method = methods[method];
    _method(resource, params, config)
      .then((r) => {
        processSuccessfullLocalAPIResponse(vm, r)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            if (err.type && err.type == "NOT_ALLOWED") {
              window.jQuery("body").toast({
                showProgress: "bottom",
                classProgress: "blue",
                title: vm.$t("resource not allowed"),
                message:
                  vm.$t("do you want to request this permission?") +
                  ` [${err.resource}]`,
                classActions: "basic left",
                actions: [
                  {
                    text: vm.$t("yes"),
                    class: "olive",
                    click: function () {
                      requestPermission(vm, err.resource);
                    },
                  },
                ],
              });
            } else {
              reject(c.stringify(err));
            }
          });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

exports.toast = (target, type, message) => {
  let configs = {
    error: { class: "error", image: "/images/error.png", title: "Error" },
    success: {
      class: "success",
      image: "/images/success.png",
      title: "Success",
    },
  };

  let config = configs[type];

  window.jQuery(target).toast({
    message: message,
    class: config.class,
    showImage: config.image,
    classImage: "avatar",
    title: config.title,
    showProgress: "bottom",
    classProgress: "blue",
  });
};

exports.clone = (source) => {
  return JSON.parse(JSON.stringify(source));
};

exports.error_toast = (err) => {
  console.log(err);
  if (typeof err == "object") err = JSON.stringify(err, null, 2);
  window.jQuery("body").toast({
    message: err,
    class: "error",
    showImage: "/images/error.png",
    classImage: "avatar",
    title: "Error",
    showProgress: "bottom",
    classProgress: "blue",
  });
};

exports.warning_toast = (err) => {
  if (typeof err == "object") err = JSON.stringify(err, null, 2);
  window.jQuery("body").toast({
    message: err,
    class: "warning",
    showImage: "/images/icons/warning.png",
    classImage: "avatar",
    title: "Warning",
    showProgress: "bottom",
    classProgress: "blue",
  });
};

exports.success_toast = (err) => {
  if (typeof err == "object") err = JSON.stringify(err, null, 2);
  window.jQuery("body").toast({
    message: err,
    class: "success",
    showImage: "/images/success.png",
    classImage: "avatar",
    title: "Success",
    showProgress: "bottom",
    classProgress: "blue",
    position: "top center",
  });
};

exports.load_submodules = (vm, parent_module) => {
  this.local_api(vm, "post", "/system/do-get-submodules", {
    module: parent_module,
  })
    .then((submodules) => {
      vm.submodules = submodules;
    })
    .catch((err) => {
      console.error(err);
    });
};

exports.download_resource = (vm, resource_url, filename) => {
  vm.$http({
    method: "get",
    url: resource_url,
    responseType: "arraybuffer",
  })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
    })
    .catch(() => console.log("error occured"));
};

exports.normalize_error = (vm, error) => {
  let err = "";
  if (typeof error == "string") err = error;
  else err = JSON.stringify(error);
  vm.$alertify.error(err);
};

// eslint-disable-next-line no-unused-vars
var re_login = (vueInstance) => {
  var local_api = this.local_api;

  vueInstance.$alertify
    .prompt(
      vueInstance.$t("re-enter your password"),
      "",
      function (event, value) {
        var sha1 = require("js-sha1");
        var passwd = sha1(value);
        var user = vueInstance.$session.get("user").username;
        local_api(vueInstance, "post", "/auth/do-auth", {
          u: user,
          p: passwd,
        })
          .then(function (rspns) {
            if (!rspns) {
              vueInstance.$alertify.error("Invalid authentication");
              re_login(vueInstance);
            } else {
              vueInstance.$session.start();
              vueInstance.$session.set("token", rspns.token);
              vueInstance.$session.set("user", rspns.user);
              location.reload();
            }
          })
          .catch(function (err) {
            vueInstance.$alertify.error(err);
          })
          .finally(() => {});
      },
      function () {
        vueInstance.$session.destroy();
        vueInstance.$router.replace({ name: "Index" });
      },
    )
    .set("type", "password");
};

var processSuccessfullLocalAPIResponse = (vueInstance, response) => {
  return new Promise(function (resolve, reject) {
    if (response.status === 200) {
      if (!response.data.success) {
        if (response.data.error == "SESSION_EXPIRED") {
          // re_login(vueInstance);
          vueInstance.$session.destroy();
          vueInstance.$router.replace({ name: "Index" });
        } else {
          reject(response.data.error);
        }
      } else resolve(response.data.data);
    }
  });
};

exports.stringify = (target) => {
  if (typeof target != "string") return JSON.stringify(target);
  else return target;
};

exports.init_local_data_datables = (
  vm,
  reference,
  onSelect,
  onCreatedRow,
  opts = {},
) => {
  // let dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/English.json";
  let dict = "/third_party/datatables/English.json";
  if (vm.$i18n.locale == "es") dict = "/third_party/datatables/Spanish.json";
  // dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/Spanish.json";
  else if (vm.$i18n.locale == "fr")
    dict = "/third_party/datatables/French.json";
  // dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/French.json";

  let ordering = opts.ordering != undefined ? opts.ordering : true;

  if (window.jQuery.fn.DataTable.isDataTable(reference)) {
    window.jQuery(reference).DataTable().destroy();
  } else {
    return window.jQuery(reference).DataTable({
      language: {
        url: dict,
      },
      ordering: ordering,
      createdRow: function (row, data) {
        if (typeof onCreatedRow == "function") {
          onCreatedRow(row, data);
        }
        window.jQuery(row).click(function (event) {
          if (typeof onSelect == "function") {
            onSelect(data, event);
          }
        });
      },
    });
  }
};

exports.init_json_local_data_datables = (
  vm,
  reference,
  data,
  columns,
  onSelect,
  onCreatedRow,
  onPageChanged,
) => {
  // let dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/English.json";
  let dict = "/third_party/datatables/English.json";
  if (vm.$i18n.locale == "es") dict = "/third_party/datatables/Spanish.json";
  // dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/Spanish.json";
  else if (vm.$i18n.locale == "fr")
    dict = "/third_party/datatables/French.json";
  // dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/French.json";

  if (window.jQuery.fn.DataTable.isDataTable(reference)) {
    let datatable = window.jQuery(reference).DataTable();
    datatable.clear().draw();
    datatable.rows.add(data); // Add new data
    datatable.columns.adjust().draw(); // Redraw the DataTable
    // window
    //   .jQuery(reference)
    //   .DataTable()
    //   .destroy();
  } else {
    let tbl = window.jQuery(reference).DataTable({
      retrieve: true,
      autoWidth: true,
      ordering: true,
      scrollCollapse: true,
      data: data,
      language: {
        url: dict,
      },
      columns: columns,
      createdRow: function (row, data) {
        if (typeof onCreatedRow == "function") {
          onCreatedRow(row, data);
        }
        window.jQuery(row).click(function (event) {
          if (typeof onSelect == "function") {
            onSelect(data, event);
          }
        });
      },
    });
    if (typeof onPageChanged == "function") {
      tbl.on("page.dt", function () {
        onPageChanged();
      });
    }
  }

  // window
  //   .jQuery(reference)
  //   .find("tbody")
  //   .empty();
};

exports.init_ajax_data_datables = (
  vm,
  reference,
  url,
  columns,
  onSelect,
  onCreatedRow,
  requestTransform,
) => {
  // let dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/English.json";
  let dict = "/third_party/datatables/English.json";
  if (vm.$i18n.locale == "es") dict = "/third_party/datatables/Spanish.json";
  // dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/Spanish.json";
  else if (vm.$i18n.locale == "fr")
    dict = "/third_party/datatables/French.json";
  // dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/French.json";

  if (window.jQuery.fn.DataTable.isDataTable(reference)) {
    let datatable = window.jQuery(reference).DataTable();
    if (datatable.ajax && datatable.ajax.reload) {
      datatable.ajax.reload();
    }
    datatable.ajax.reload();
    return datatable;
  } else {
    let transf = function () {};
    if (typeof requestTransform == "function") {
      transf = requestTransform;
    }

    let tbl = window.jQuery(reference).DataTable({
      processing: true,
      serverSide: true,
      info: false,
      pageLength: 10,
      language: {
        url: dict,
      },
      ajax: {
        url: url,
        type: "post",
        beforeSend: function (request) {
          let token = vm.$session.get("token");
          if (token) {
            request.setRequestHeader("x-access-token", token);
          }
        },
        data: transf,
        dataSrc: function (json) {
          if (!json.success) {
            if (json.error == "SESSION_EXPIRED") {
              // re_login(vueInstance);
              vm.$router.replace({ name: "Index" });
            } else if (json.error && json.error.type == "NOT_ALLOWED") {
              window.jQuery("body").toast({
                showProgress: "bottom",
                classProgress: "blue",
                title: vm.$t("resource not allowed"),
                message:
                  vm.$t("do you want to request this permission?") +
                  ` [${json.error.resource}]`,
                classActions: "basic left",
                actions: [
                  {
                    text: vm.$t("yes"),
                    class: "olive",
                    click: function () {
                      requestPermission(vm, json.error.resource);
                    },
                  },
                ],
              });
            } else vm.$alertify.error(json.error);
          } else return json.data;
        },
      },
      columns: columns,
      createdRow: function (row, data) {
        if (typeof onCreatedRow == "function") {
          onCreatedRow(row, data);
        }
        window.jQuery(row).click(function (event) {
          if (typeof onSelect == "function") {
            onSelect(data, event);
          }
        });
      },
    });
    return tbl;
  }
};

exports.init_search = (
  vm,
  reference,
  action,
  onResponse,
  onSelect,
  opts = {},
) => {
  let t = this;
  // console.log("initing search control", opts);
  let maxResults = opts.maxResults || 10;
  window.jQuery(reference).search({
    apiSettings: {
      action: action,
      beforeXHR: function (xhr) {
        let token = vm.$session.get("token");
        if (token) {
          xhr.setRequestHeader("x-access-token", token);
        }
        return xhr;
      },
      onResponse: function (response) {
        if (!response.success) t.error_toast(response.error);
        else {
          var _response = onResponse(response.data);
          return _response;
        }
      },
    },
    onSelect: onSelect,
    maxResults: maxResults,
  });
};

exports.loadDataTablesLibraries = () => {
  let arr = [
    "https://cdn.datatables.net/buttons/2.0.1/js/dataTables.buttons.min.js",
    "https://cdnjs.cloudflare.com/ajax/libs/jszip/3.1.3/jszip.min.js",
    "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.53/pdfmake.min.js",
    "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.53/vfs_fonts.js",
    "https://cdn.datatables.net/buttons/2.0.1/js/buttons.html5.min.js",
    "https://cdn.datatables.net/buttons/2.0.1/js/buttons.print.min.js",
  ];
  arr.forEach((ar) => {
    const plugin = document.createElement("script");
    plugin.setAttribute("src", ar);
    plugin.async = true;
    document.head.appendChild(plugin);
  });
};

exports.reload_session = (vm) => {
  let c = this;
  c.local_api(vm, "post", "/user/do-reload-session", {})
    .then(() => {
      c.success_toast(vm.$t("session reloaded"));
    })
    .catch((err) => {
      c.error_toast(err);
    });
};

var requestPermission = (vm, resource) => {
  let c = this;
  c.local_api(vm, "post", "/system/do-request-resource-permission", {
    r: resource,
  })
    .then(() => {
      c.reload_session(vm);
    })
    .catch((err) => {
      this.error_toast(err);
    });
};

exports.enterprise_setup = (vm) => {
  if (vm) {
    let enterpriseSetup = vm.$session.get("enterprise_setup");
    return enterpriseSetup || {};
  }
};

exports.download_content = (data, name) => {
  var blob = new Blob([JSON.stringify(data, null)], {
    type: "application/json;charset=utf-8",
  });
  var url = URL.createObjectURL(blob);
  var elem = document.createElement("a");
  elem.href = url;
  elem.download = name;
  document.body.appendChild(elem);
  elem.click();
  document.body.removeChild(elem);
};

exports.register_listener = (name, func) => {
  window.jQuery(window).off(name);
  window.jQuery(window).on(name, func);
};
